// Cupom de desconto (na retaguarda o nome e "voucher").
//
// O cadastro real tem UM tipo de desconto, nao dois: a listagem da retaguarda mostra
// as colunas de R$ e de % lado a lado e da a impressao de que sao campos independentes,
// mas a tela de edicao tem um campo `Tipo` com exatamente duas opcoes - Valor ou
// Percentual - e um unico campo de valor.
//
// Enquanto o `sirius-s` nao expuser voucher (hoje da 404), a busca e mockada. A
// validacao de verdade PRECISA ser do servidor: o `pedido/grava` aceita o desconto que
// o front mandar, entao desconto calculado no navegador e forjavel. Contrato proposto
// em `docs/HANDOFF-BACKEND-cupom.md`.

export enum VoucherTipo {
  Valor = 10,
  Percentual = 20,
}

// Data no formato 'AAAA-MM-DD' no fuso LOCAL. Comparar datas como texto ISO evita o
// erro classico de `new Date('2026-02-26')` virar meia-noite UTC e cair no dia anterior
// para quem esta a oeste de Greenwich - que e o caso do Brasil inteiro.
export function voucherDia(data: Date): string {
  const mes = `${data.getMonth() + 1}`.padStart(2, '0');
  const dia = `${data.getDate()}`.padStart(2, '0');
  return `${data.getFullYear()}-${mes}-${dia}`;
}

export class Voucher {
  codigo: string;
  nome: string;
  tipo: VoucherTipo;
  valor: number;
  // 'AAAA-MM-DD'. Vazio significa sem limite daquele lado.
  inicio: string;
  conclusao: string;
  ativo: boolean;

  validoEm(data: Date): boolean {
    if (!this.ativo) {
      return false;
    }
    const dia = voucherDia(data);
    if (this.inicio && dia < this.inicio) {
      return false;
    }
    if (this.conclusao && dia > this.conclusao) {
      return false;
    }
    return true;
  }

  // O desconto nunca passa do subtotal: cupom nao vira credito nem deixa o pedido
  // negativo. Frete fica de fora de proposito - se o desconto tambem abate a entrega,
  // e uma regra de negocio que ainda nao foi definida (ver o handoff).
  descontoCalcula(subtotal: number): number {
    const base = subtotal > 0 ? subtotal : 0;
    if (!base) {
      return 0;
    }
    const bruto =
      this.tipo === VoucherTipo.Percentual ? (base * this.valor) / 100 : this.valor;
    const limitado = Math.min(Math.max(bruto, 0), base);
    // Duas casas, para nao gerar centavo de dizima no total.
    return Math.round(limitado * 100) / 100;
  }

  // Como o desconto aparece para o cliente: "50% de desconto" ou "R$ 5,00 de desconto".
  resumo(): string {
    if (this.tipo === VoucherTipo.Percentual) {
      const percentual = Number.isInteger(this.valor)
        ? `${this.valor}`
        : this.valor.toFixed(2).replace('.', ',');
      return `${percentual}% de desconto`;
    }
    return `R$ ${this.valor.toFixed(2).replace('.', ',')} de desconto`;
  }
}
